import * as React from 'react'
import { Container } from 'react-bootstrap'
import { useRouteMatch } from 'react-router'

import { ClientObj, ClientT } from '../../types/Users'
import { companyObj, CompanyT, VariablesT, VariablesObj } from '../../types/Company'

import { copyObject } from '../../components/TimerView'

import ScreenAgreement from './ScreenAgreement'
import ScreenClientIntro from './ScreenClientIntro'
import ScreenNewClient from './ScreenNewClient'
import ScreenClientHome from './ScreenClientHome'
import ScreenJobQuestions, { initFieldsJobQuestions } from './ScreenJobQuestions'
import ScreenLocations from './ScreenLocations'
import ScreenFormStripe from './ScreenFormStripe'
import { LocationObj } from '../jobs/NewJob/InitObjectJob'
import { JobT, LocationT } from '../../types/Job'
import { IAppState } from '../../redux/reducers'
import { useSelector } from 'react-redux'
import axios from 'axios'


export interface FieldsCreateJobT {
  jobType: string
  token: string
  duration: number
  moveDate: string
  startTime: string
  locations: Array<LocationT>,
}

export interface ClientExtendsT extends ClientT {
  password: string
  rePassword: string
}

export type CurrentScreenT = 'Agreement' | 'ClientIntro' | 'ClientHome' | 'NewClient' | 'Locations' | 'JobQuestions' | 'FormStripe'

interface BookingProps {
  company?: CompanyT
  handle?: string
}

const Booking: React.FunctionComponent<BookingProps> = (props): JSX.Element => {
  const auth = useSelector((state: IAppState) => state.auth)
  const [client, setClient] = React.useState<ClientExtendsT>(copyObject(ClientObj))
  const [company, setCompany] = React.useState<CompanyT>(companyObj)
  const [deposit, setDeposit] = React.useState(0)
  const [emailNotFound, setEmailNotFound] = React.useState(false)

  const [screenIndex, setScreenIndex] = React.useState(0)

  const [token, setToken] = React.useState(null)

  const [currentScreen, setCurrentScreen] = React.useState<CurrentScreenT>('ClientIntro')
  const [previousScreen, setPreviousScreen] = React.useState<CurrentScreenT>('ClientIntro')
  // const [currentScreen, setCurrentScreen] = React.useState<CurrentScreenT>('NewClient')
  // const [previousScreen, setPreviousScreen] = React.useState<CurrentScreenT>('NewClient')

  const [tokenUser, setTokenUser] = React.useState(null);
  const [locations, setLocations] = React.useState([copyObject(LocationObj)])
  const match = useRouteMatch()
  const [fieldsJobQuestions, setFieldsJobQuestions] = React.useState(initFieldsJobQuestions);
  const [selectJob, setSelectJob] = React.useState<JobT | null>(null);

  const [variables, setVariables] = React.useState<VariablesT>(VariablesObj);
  const [fieldsCreateJob, setFieldsCreateJob] = React.useState<FieldsCreateJobT>(null)

  React.useEffect(() => {

    if (props.company) {
      initCompany(props.company)
    } else {
      if (match && match.params && match.params.token) {
        if (match.params.token != "" && match.params.token != null) {
          setToken(match.params.token)
          validateToken(match.params.token)
        }
      }
    }

    if (auth?.token) {
      setCurrentScreen("ClientHome")
    }
  }, [])

  const validateToken = async (token) => {
    let params = {
      token: token,
    }
    // check token from back-end server-node
    axios.post(`/validateToken`, params).then(res => {
      if (res && res.status == 200 && res.data && res.data.client) {
        let company = { ...companyObj, ...res.data.client }
        initCompany(company)
      } else {

      }
    }).catch((error) => {

    })
  }

  const initCompany = (company: CompanyT) => {
    setCompany(company)
    let variablesClone = { ...VariablesObj, ...company.variables }
    setVariables(variablesClone)
    setDeposit(variablesClone.depositLocal.value)
  }



  const showScreen = (): JSX.Element => {
    console.log("company->showScreen", company)
    switch (currentScreen) {
      case 'ClientIntro':
        return (
          <ScreenClientIntro
            handle={props.handle}
            token={token}
            nextScreen={(fields, _emailNotFound, token, _client) => {
              if (_emailNotFound) {
                let tempClient = copyObject(client)
                tempClient.email = fields.email
                tempClient.password = fields.password
                setClient(tempClient)
                setCurrentScreen('NewClient')

                // setJobs(foundJobs)
              } else {
                setClient({ ...client, ..._client })
                setTokenUser(token)
                setCurrentScreen('ClientHome')
              }
              setPreviousScreen('ClientIntro')
              setScreenIndex(1)

            }} />
        )
      case 'NewClient':
        return <ScreenNewClient
          handle={props.handle}
          token={token}
          email={client.email}
          back={() => {
            setScreenIndex(0)
            setPreviousScreen('ClientIntro')
            setCurrentScreen('ClientIntro')
            setEmailNotFound(false)
          }}
          nextScreen={(client, authTokenUser) => {
            setTokenUser(authTokenUser)
            setClient(client)
            setPreviousScreen('NewClient')
            setCurrentScreen('Locations')
          }}
        />
      case 'Agreement':
        return <ScreenAgreement
          handle={props.handle}
          fieldsCreateJob={fieldsCreateJob}
          tokenUser={tokenUser}
          company={company}
          nextScreen={() => {
            setLocations([copyObject(LocationObj)])
            setFieldsJobQuestions(initFieldsJobQuestions)
            setPreviousScreen('ClientHome')
            setCurrentScreen('ClientHome')
          }}
          goBack={() => {
            setPreviousScreen('Agreement')
            setCurrentScreen('JobQuestions')
          }} />
      case 'ClientHome':
        return <ScreenClientHome
          client={client}
          tokenUser={tokenUser}
          bookJob={(job) => {
            setSelectJob(job)
            setPreviousScreen('ClientHome')
            setCurrentScreen('FormStripe')
          }}
          bookedJob={(job) => {

          }}
          newMovingInquiry={() => {
            setPreviousScreen('ClientHome')
            setCurrentScreen('Locations')
          }} />

      case 'Locations':
        return <ScreenLocations
          locations={locations}
          nextScreen={(newLocations) => {
            setLocations(newLocations)
            setPreviousScreen('Locations')
            setCurrentScreen('JobQuestions')
          }}
        />
      case 'JobQuestions':
        return <ScreenJobQuestions
          handle={props.handle}
          company={company}
          companyVariables={variables}
          token={token}
          locations={locations}
          tokenUser={tokenUser}
          fields={fieldsJobQuestions}
          onChangeeFields={(fields) => {
            setFieldsJobQuestions(fields)
          }}
          nextScreen={(fieldsCreateJob: FieldsCreateJobT) => {
            // reset fields
            setFieldsCreateJob(fieldsCreateJob)
            setPreviousScreen('JobQuestions')
            setCurrentScreen('Agreement')
          }}
          goBack={() => {
            setCurrentScreen(previousScreen)
          }} />
      case 'FormStripe':
        return <ScreenFormStripe
          deposit={deposit}
          company={company}
          job={selectJob}
          user={client}
          tokenUser={tokenUser}
          goBack={(hasPaid) => {
            if (hasPaid) {
              setLocations([copyObject(LocationObj)])
              setFieldsJobQuestions(initFieldsJobQuestions)
            }
            setCurrentScreen(previousScreen)
          }} />
      default:
        return null
    }
  }

  return (
    <Container>
      <div style={{ padding: '16px 8px' }} className='booking-wrapper'>
        <h2 style={{ marginBottom: 20 }}>Booking</h2>
        {showScreen()}
      </div>
    </Container>
  )
}

export default Booking
